<template>
  <div></div>
</template>

<script>
export default {
  name: 'VchRfpMctb',
  props: {
    productItemId: {
      type: String,
      default: '',
    },
    variantItemId: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.varientComponentAPI();
  },
  methods: {
    varientComponentAPI() {
      if (this.productItemId !== '' && this.variantItemId !== '') {
        setTimeout(() => {
          window.eventBus.$emit('rfp-mctb-has-varient-component', {
            productItemId: this.productItemId.toUpperCase(),
            varintItemId: this.variantItemId.toUpperCase(),
          });
        }, 500);
      }
    },
  },
};
</script>
